module.exports = __webpack_public_path__ + "media/images/koala-logo-27e4a174de4dd098baf32c7606ac2ee4.svg";